<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="deleteBranchDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Delete Branch</div
  >

  <div
    class="text-s1 mt-6 text-lg"
    *ngIf="ref.data.repoType !== repoTypeEnum.Production"
    >Are you sure you want to delete branch
    <span class="font-semibold">
      {{ ref.data.branchId }}
    </span>
    in
    <span class="font-semibold"> dev-{{ repoName }} </span>
    repository ?</div
  >

  <div
    class="text-s1 mt-6 text-lg"
    *ngIf="ref.data.repoType === repoTypeEnum.Production"
    >Are you sure you want to delete branch
    <span class="font-semibold">
      {{ ref.data.branchId }}
    </span>
    in
    <span class="font-semibold"> Production </span>
    and
    <span class="font-semibold"> Remote </span>
    repositories ?</div
  >

  <div class="mt-6">
    <button
      data-cy="deleteBranchDialogDeleteButton"
      class="bg-r1 text-m0 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      (click)="delete()"
      >Delete</button
    >

    <button
      data-cy="deleteBranchDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>
